import { gql } from "lib/apolloClient";
import { attachmentFragment, userFragment } from "modules/CommonFragments";

export const learnerPortfolioFragment = {
  learnerPortfolio: gql`
    fragment learnerPortfolioItem on LearnerPortfolio {
      id
      isArchived
      yearGroup {
        id
        name
        grade {
          id
          name
        }
      }
      studentLearnerPortfolios {
        totalCount
      }
    }
  `,
  studentLearnerPortfolio: gql`
    fragment studentLearnerPortfolioItem on StudentLearnerPortfolioConnection {
      totalCount
      edges {
        node {
          id
          student {
            ...userItem
          }
          postCount
          lastModifiedAt
        }
      }
    }
    ${userFragment.basicUserDetails}
  `,
};

export const learnerPortfolioPostFragment = {
  learnerPortfolioPost: gql`
    fragment learnerPortfolioPostItem on Post {
      id
      title
      course {
        id
      }
      state
      createdAt
      attachments {
        ...attachmentItem
      }
      learnerPortfolioCollection {
        id
        label
        parentHierarchy {
          id
        }
      }
      folders {
        id
        name
      }
    }
    ${attachmentFragment.attachment}
  `,
};

export const subjectFragment = {
  subject: gql`
    fragment subjectItem on Subject {
      id
      name
    }
  `,
};

export const learnerPortfolioCollectionFragment = {
  collection: gql`
    fragment collectionItem on OrganizationResourceConnection {
      resourceTypeBasedCount {
        totalCount
      }
      edges {
        node {
          id
          label
          type
          resourceType
          metadata
          entity {
            id
            ...subjectItem
          }
          childrenV2(filters: $postFilters) {
            resourceTypeBasedCount {
              totalCount
            }
            edges @skip(if: $skipPostData) {
              node {
                id
                label
                type
                resourceType
                entity {
                  id
                  ...subjectItem
                }
                item {
                  id
                  ...learnerPortfolioPostItem
                }
              }
            }
          }
        }
      }
    }
    ${learnerPortfolioPostFragment.learnerPortfolioPost}
    ${subjectFragment.subject}
  `,
  collectionList: gql`
    fragment collectionListItem on OrganizationResourceConnection {
      edges {
        node {
          id
          label
          type
          resourceType
          entity {
            id
            ...subjectItem
          }
        }
      }
    }
    ${subjectFragment.subject}
  `,
  collectionLabel: gql`
    fragment collectionLabelItem on OrganizationResourceConnection {
      edges {
        node {
          id
          label
          entity {
            id
            ...subjectItem
          }
        }
      }
    }
    ${subjectFragment.subject}
  `,
};

export const organizationResourceFragment = {
  organizationResource: gql`
    fragment organizationResourceItem on OrganizationResource {
      id
      label
      metadata
      attachment {
        ...attachmentItem
      }
      isImported: isImportedFromDiffOrg
      isDeleted
      isArchived
      status
      type
      resourceType
      visibleTo
      createdAt
      updatedAt
      tags {
        id
        key
        value
      }
    }
    ${attachmentFragment.attachment}
  `,
  organizationResourceForCollection: gql`
    fragment organizationResourceItemCollection on OrganizationResource {
      id
      label
      type
      resourceType
      entity {
        id
        ...subjectItem
      }
      childrenV2(filters: $collectionFilters) {
        ...collectionItem
      }
    }
    ${learnerPortfolioCollectionFragment.collection}
    ${subjectFragment.subject}
  `,
};
